import {LongYellowLine} from "../../svg/LongYellowLine";
import {PatternFormat} from "react-number-format";
import {Switch} from "../Switch";
import {Popup} from "../account/Popup";
import React, {useEffect, useState} from "react";
import {ProductInterface} from "../../interfaces/product/product.interface";
import {useProductSelector} from "../../stores/product/product.store";
import {ProductState} from "../../stores/product/product-state.interface";
import {UserService} from "../../services/user.service";

interface NotificationModalProps {
    isOpen: boolean;
    onClose: () => void;
    product: ProductInterface;
}

export const NotificationModal = ({
                                      isOpen,
                                      onClose,
                                      product,
  }: NotificationModalProps) => {
    if (!isOpen) return null;

    const translate = useProductSelector((state: ProductState) => state.translate);
    const [phone, setPhone] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [lastName, setLastName] = useState('');
    const [firstName, setFistName] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [validEmail, setValidEmail] = useState(false);
    const [agree, setAgree] = useState(true);
    const [sendText, setSendText] = useState('');

    useEffect(() => {
        const isValid = Boolean(
            phone.replaceAll(' ', '').length === 12
            && firstName.trim().length > 2
            && lastName.trim().length > 2
            && validEmail
        );
        setDisabled(!isValid);
    }, [validEmail, firstName, lastName, phone]);

    const changePhoneNumber = (number: string) => {
        setPhone(number);
    }

    const checkFirstDigit = (inputValue: string) => {
        const digits = inputValue.replace(/\D/g, '');
        return digits.length === 0 || digits[0] === '6' || digits[0] === '7';
    };

    const close = (cross: boolean) => {
        onClose();
    }

    const send = () => {
        setDisabled(true);
        fetch('index.php?route=product/product/sendNotification', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                {
                    id: product.id,
                    firstName,
                    lastName,
                    phone,
                    email,
                    roistatVisit: (window as any)?.roistat?.getVisit() || '',
                    roistatSource: (window as any)?.roistat?.getSource() || '',
                    agree: Boolean(agree)
                }
            )
        })
            .then(response => response.json())
            .then(r => setSendText(r.message))
            .catch(err => setSendText('Ceva nu a mers bine. Incearca mai tarziu'))
            .finally(() => setDisabled(false))
    }

    const isEmailValid = (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if(regex.test(email)) {
            UserService.validEmail(email).then(() => {
                setValidEmail(true);
            }).catch(e => {
                setValidEmail(false);
                setEmailError(e.response.data.message);
            });
        } else {
            setValidEmail(false);
        }
    }

    const changeEmail = (value: string) => {
        setEmailError('');
        setEmail(value);
        isEmailValid(value);
    }

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    return (
        <Popup onClose={ close }>
            <div className="max-w-full md:max-w-[600px] flex justify-center w-full">
                <div className="px-4 py-5 md:px-6 md:py-8">
                    <div className="mb-6">
                        <p className="uppercase text-3xl md:text-4xl mb-4 smart-font md:mr-10">{ translate.notificationInStock }</p>
                        <LongYellowLine/>
                    </div>
                    { !sendText && <p className="text-gray text-[16px] font-medium mb-4">{ translate.leaveData }</p> }
                    { sendText ? <div>{ sendText }</div> :
                        <div>
                            <div className="w-full mb-6">
                                <label htmlFor="lastName"
                                       className="text-sm font-medium mb-3 block text-black">{ translate.lastName }</label>
                                <input id="lastName"
                                       type="text"
                                       className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl"
                                       value={ lastName }
                                       onChange={ (e) => setLastName(e.target.value) }/>
                            </div>
                            <div className="w-full mb-6">
                                <label htmlFor="firstName"
                                       className="text-sm font-medium mb-3 block text-black">{ translate.firstName }</label>
                                <input id="firstName"
                                       type="text"
                                       className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl"
                                       value={ firstName }
                                       onChange={ (e) => setFistName(e.target.value) }/>
                            </div>
                            <div className="w-full mb-5">
                                <label htmlFor="phone"
                                       className="text-base font-medium mb-3 block text-black">{ translate.phone }</label>
                                <PatternFormat
                                    id="phone"
                                    placeholder="Введите ваш телефон"
                                    value={ phone }
                                    onChange={ (e) => changePhoneNumber(e.target.value) }
                                    format="+373 ########"
                                    type="tel"
                                    isAllowed={ ({ value }) => checkFirstDigit(value) }
                                    allowEmptyFormatting
                                    className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl font-medium"
                                />
                            </div>
                            <div className="w-full mb-6">
                                <label htmlFor="email"
                                       className="text-sm font-medium mb-3 block text-black">{ translate.email }</label>
                                <input id="name"
                                       type="text"
                                       className="p-4 bg-light-gray w-full h-14 box-border border-none caret-yellow rounded-xl"
                                       value={ email }
                                       onChange={ (e) => changeEmail(e.target.value) }/>
                                { emailError && <span className="text-sm mt-1 text-error">{ emailError }</span> }
                            </div>
                            <div className="mb-5 flex justify-between items-center">
                                <label className="text-black text-sm mr-2"
                                       htmlFor="terms">{ translate.notificationAgree }</label>
                                <Switch id="notifications" checked={ agree } onChange={ setAgree }/>
                            </div>
                            <div className="w-full text-center">
                                <button
                                    className={ `w-full rounded-xl ${ disabled ? 'bg-light-dark-gray' : 'bg-dark-gray' } text-white h-14` }
                                    disabled={ disabled }
                                    onClick={ () => send() }>{ translate.send }
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </Popup>
    );
};